import * as ApiWithToken from "../callApiWithToken";
import { ICreateUser } from "../../models/input/userApi/ICreateUser";
import { IUpdateUser } from "../../models/input/userApi/IUpdateUser";
import { IManageUser } from "../../models/input/userApi/IManageUser";
import { IAbsenceMassiveIn } from "../../models/input/generalApi/IAbsenceMassiveIn";

const apiUrl = process.env.REACT_APP_GENERAL_API;
const apiUrlAgenda = process.env.REACT_APP_AGENDAS_API;

const UsersManagementService = {
  getUsers: async function (languageId: number) {
    return ApiWithToken.getApi(
      `${apiUrl}Users/getUsers?languageId=${languageId}`
    );
  },

  getSupervisorList: async function () {
    return ApiWithToken.getApi(`${apiUrl}DataList/getSupervisorList`);
  },

  getRolesList: async function (languageID: number) {
    return ApiWithToken.getApi(
      `${apiUrl}DataList/getRolesList?languageId=${languageID}`
    );
  },

  getTimeList: async function (languageID: number) {
    return ApiWithToken.getApi(
      `${apiUrl}DataList/getTimesByRole?languageId=${languageID}`
    );
  },

  getPartnerList: async function () {
    return ApiWithToken.getApi(`${apiUrl}DataList/getPartner`);
  },

  getFundList: async function (partnerID: number, categoryFundID: number) {
    return ApiWithToken.getApi(
      `${apiUrl}DataList/getFundsByPartner?partnerId=${partnerID}&categoryFundId=${categoryFundID}`
    );
  },

  getCountriesList: async function () {
    return ApiWithToken.getApi(`${apiUrl}DataList/getCountriesList`);
  },

  getStateList: async function (countryID: number) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetStateByCountry?countryId=${countryID}`
    );
  },

  getCityList: async function (stateID: number) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetCityByState?stateId=${stateID}`
    );
  },

  getAdviserList: async function (cityID: number) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetAdvisorsBySupervisors?cityId=${cityID}`
    );
  },

  postCreateUser: async function (form: ICreateUser) {
    return ApiWithToken.postApi(`${apiUrl}Users/createUser`, form);
  },

  putDeleteUser: async function (userId: number) {
    return ApiWithToken.putApi(`${apiUrl}Users/deleteUser`, {
      staffID: 0,
      userID: userId,
    });
  },

  putUpdateUser: async function (form: IUpdateUser) {
    return ApiWithToken.putApi(`${apiUrl}Users/updateUser`, form);
  },

  getAttendanceByRole: async function (
    date: string,
    periodType: number,
    languageId: number,
    status: number,
    supervisorId?: number | null
  ) {
    let url = `${apiUrl}Users/getAttendanceByRoleWeb?date=${date}&periodType=${periodType}&languageID=${languageId}&status=${status}`;
  
    if (supervisorId !== null && supervisorId !== undefined) {
      url += `&supervisorID=${supervisorId}`;
    }
  
    return ApiWithToken.getApi(url);
  },

  getTempateUsersManagementMassive: async function (actionTypeID: number, languageID: number) {
    let url = `${apiUrl}Users/GetTemplateUsersManagementMassive?actionTypeID=${actionTypeID}&languageId=${languageID}`;
    return ApiWithToken.getApiBlob(url);
  },

  manageUsersInBulk: async function (json: IManageUser[], actionTypeID: number) {
    return ApiWithToken.putApi(`${apiUrl}Users/ManageUsersInBulk?actionTypeID=${actionTypeID}`, json);
  },

  getTempateAbsencesMassive: async function (languageID: number) {
    let url = `${apiUrl}Absences/GetTemplateAbsences?languageId=${languageID}`;
    return ApiWithToken.getApiBlob(url);
  },

  createAbsencesInBulk: async function (json: IAbsenceMassiveIn[]) {
    return ApiWithToken.putApi(`${apiUrl}Absences/CreateAbsencesInBulk`, json);
  },

  getAttendanceExcel: async function (
    date: string,
    periodType: number,
    languageId: number,
    supervisorId?: number | null
  ) {
    let url = `${apiUrl}Users/GetAttendanceExcel?date=${date}&periodType=${periodType}&languageID=${languageId}`;
  
    if (supervisorId !== null && supervisorId !== undefined) {
      url += `&supervisorID=${supervisorId}`;
    }
    return ApiWithToken.getApiBlob(url);
  },

    getAttendanceByRoute: async function (
    date: string,
    periodType: number,
    languageId: number,
    status: number,
    supervisorId?: number | null
  ) {
    let url = `${apiUrl}Users/getAttendanceByRoutesWeb?date=${date}&periodType=${periodType}&languageID=${languageId}&status=${status}`;
  
    if (supervisorId !== null && supervisorId !== undefined) {
      url += `&supervisorID=${supervisorId}`;
    }
  
    return ApiWithToken.getApi(url);
  },
    
    getAttendanceRouteExcel: async function (
    date: string,
    periodType: number,
    languageId: number,
    supervisorId?: number | null
  ) {
    let url = `${apiUrl}Users/GetAttendanceRouteExcel?date=${date}&periodType=${periodType}&languageID=${languageId}`;
  
    if (supervisorId !== null && supervisorId !== undefined) {
      url += `&supervisorID=${supervisorId}`;
    }
    return ApiWithToken.getApiBlob(url);
  },

};

export default UsersManagementService;
